export default "__VITE_ASSET__DAPDfmJn__"